import { BaseService } from '@/core/base-service';

export default class PaymentTypeService extends BaseService<any> {
  public constructor() {
    super('services/servicescard/api/admin/payment-type');
  }
}
